import moment from 'moment';

export const formatToKotcharam = date =>  moment(date, "YYYY-MM-DD hh:mm a").format('DD-MMM-YYYY hh:mm a');
export const formatDatePickerToDate = date =>  moment(date, "EEE, MMM DD YYYY hh:mm a").format('DD-MMM-YYYY hh:mm a');


export const doBToMoment = dob => moment(dob, "YYYY-MM-DD hh:mm a")
export const toDoBFormat = m => m.format("YYYY-MM-DD hh:mm a")

